var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortfolioBalanceIconInheritFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.45455 12.0909C1.05455 12.0909 0.712242 11.9486 0.427636 11.664C0.142546 11.3789 0 11.0363 0 10.6363V1.90907C0 1.50907 0.142546 1.16677 0.427636 0.882165C0.712242 0.597074 1.05455 0.454529 1.45455 0.454529H13.0909C13.4909 0.454529 13.8335 0.597074 14.1185 0.882165C14.4032 1.16677 14.5455 1.50907 14.5455 1.90907V6.27271H1.45455V10.6363H8.72727V12.0909H1.45455ZM1.45455 3.36362H13.0909V1.90907H1.45455V3.36362ZM12.3636 13.5454V11.3636H10.1818V9.90907H12.3636V7.72726H13.8182V9.90907H16V11.3636H13.8182V13.5454H12.3636ZM1.45455 10.6363V1.90907V10.6363Z",
    fill: "inherit"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioBalanceIconInheritFill);
export default __webpack_public_path__ + "static/media/portfolioBalanceIconInheritFill.9c4139fe3169d6020c664ad0a0ec4a16.svg";
export { ForwardRef as ReactComponent };